module.exports = __webpack_public_path__ + "img/william-mckinley.366deadd.png";